<template>
  <component
    :is="href ? 'a' : 'button'"
    :class="classes"
    :href="disabled ? null : href"
    :disabled="disabled"
    type="button"
    @click="handleClick"
  >
    <span v-if="icon" class="icon">
      <component :is="icon" />
    </span>
    <div v-if="$slots.default" class="content">
      <slot />
    </div>
  </component>
</template>

<script>
/**
 * ボタン
 */
export default {
  name: 'Button',
  props: {
    /** リンク先URL */
    href: { type: String, default: null },
    /** プライマリボタン */
    primary: { type: Boolean, default: false },
    /** セカンダリボタン */
    secondary: { type: Boolean, default: false },
    /** 非活性 */
    disabled: { type: Boolean, default: false },
    /** small */
    small: { type: Boolean, default: false },
    /** アイコン */
    icon: { type: Object, default: null },
  },
  computed: {
    classes() {
      return {
        button: true,
        primary: this.primary,
        secondary: this.secondary,
        small: this.small,
        iconOnly: this.icon && !this.$slots.default,
      }
    },
  },
  methods: {
    handleClick(e) {
      if (this.disabled) return
      this.$emit('click', e)
    },
  },
}
</script>

<style lang="postcss" scoped>
.button {
  align-items: center;
  appearance: none;
  background-color: var(--white);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  box-sizing: border-box;
  color: var(--text-color);
  cursor: pointer;
  display: flex;
  font-size: 18px;
  font-weight: bold;
  height: 56px;
  justify-content: center;
  line-height: 20px;
  margin: 0;
  outline: 0;
  overflow: hidden;
  padding: 4px 16px;
  text-align: center;
  text-decoration: none;
  width: 100%;

  &.primary {
    background-color: var(--brand-color);
    border: 0;
    color: var(--white);
    fill: var(--white);
    & .icon {
      fill: var(--white);
    }
  }

  &.secondary {
    color: var(--brand-color);
  }

  &[disabled] {
    background-color: var(--light-gray);
    border: 0;
    box-shadow: none;
    color: var(--white);
    cursor: default;
    fill: var(--white);
    & .icon {
      fill: var(--white);
    }
  }

  @media screen and (min-width: 768px) {
    width: 344px;
  }
}

.content {
  align-items: center;
  -webkit-box-orient: vertical;
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.icon {
  align-items: center;
  display: inline-flex;
  fill: var(--brand-color);
}

.small {
  @media screen and (max-width: 767px) {
    font-size: 14px;
    font-weight: 300;
    height: 48px;
    min-width: 160px;
    padding: 0 8px;
  }
}

.iconOnly {
  border: none;
  height: auto;
  padding: 0;
  width: auto;
  width: fit-content;

  & .icon {
    fill: var(--very-dark-gray-2);
    margin: 4px;
  }

  &[disabled] {
    background: none;
    & .icon {
      fill: var(--gray);
    }
  }
}
</style>
